// extracted by mini-css-extract-plugin
export default {"screen":"ModalWS_screen__GntTl","window":"ModalWS_window__KnUr+"};